const alphabet = 'abcdefghijklmnopqrstuvwxyz';

const incrementCodepoint = (codePoint, incrementBy) => {
  const decimal = parseInt(codePoint, 16);
  return Number(decimal + incrementBy).toString(16);
};

const A_LETTER_CODEPOINT = '1f1e6';
const codepoints = alphabet.split('').reduce((obj, currentLetter, index) => {
  return {
    ...obj,
    // construct alphabet by incrementing A letter codepoint value
    [currentLetter]: incrementCodepoint(A_LETTER_CODEPOINT, index),
  };
}, {});

const getFlagCodePointsByCountryCode = (countryCode) => {
  return [codepoints[countryCode[0]], codepoints[countryCode[1]]].join('-');
};

function FlagEmoji({
  countryCode,
  disableLazyLoading,
  size,
  style,
  className,
  ...restProps
}) {
  const getSrc = () => {
    const flagCodePoint = getFlagCodePointsByCountryCode(countryCode);
    return `https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/${flagCodePoint}.svg`;
  };

  return (
    <img
      src={getSrc()}
      alt={countryCode}
      draggable={false}
      width={size}
      height={size}
      style={{
        width: size,
        height: size,
        ...style,
      }}
      className={className}
      data-country={countryCode}
      loading={disableLazyLoading ? undefined : 'lazy'}
      {...restProps}
    />
  );
}

FlagEmoji.defaultProps = {
  size: 25,
};

export default FlagEmoji;
